import { render, staticRenderFns } from "./GlobalMenu.vue?vue&type=template&id=7cec2e4c&scoped=true&"
import script from "./GlobalMenu.vue?vue&type=script&lang=ts&"
export * from "./GlobalMenu.vue?vue&type=script&lang=ts&"
import style0 from "./GlobalMenu.vue?vue&type=style&index=0&id=7cec2e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cec2e4c",
  null
  
)

export default component.exports